import { render, staticRenderFns } from "./AddCrmConfig.vue?vue&type=template&id=8fb22680&"
import script from "./AddCrmConfig.vue?vue&type=script&lang=js&"
export * from "./AddCrmConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports